import { FC, memo, HTMLAttributes } from 'react';
import cn from 'classnames';

import BackgroundImage from '@UI/BackgroundImage';
import styles from './NewShowroomBanner.module.css';

interface NewShowroomBannerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  title: string;
  image: string;
  text: string;
}

const NewShowroomBanner: FC<NewShowroomBannerProps> = (props) => {
  const { className, image, title, text, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.banner, className)}>
      <div className={styles.imageWrapper}>
        <BackgroundImage src={image} className={styles.image} />
      </div>

      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>{text}</div>
        </div>
      </div>
    </div>
  );
};

export default memo(NewShowroomBanner);
